import axios from 'axios';
import { BASE_URL } from './constant';
import { APIError } from '../execeptions/apiError';
import {
  HTTPError,
  HTTPForbidden,
  HTTPTimeoutError,
  HTTPUnauthorized,
} from '../execeptions/httpErrors';
import { notifyUnauthorized } from './unauthorizedHandler';

export const API_REQUEST_TIMEOUT_MS = 30000;

const mapAxiosError = (error) => {
  if (error.response) {
    const {
      statusText: message,
      status: responseCode,
      data: responseBody,
      headers: responseHeaders,
    } = error.response;
    const requestHeaders = error.config?.headers;
    const errorDetails = {
      message,
      responseCode,
      responseBody,
      responseHeaders,
      requestHeaders,
    };

    if (responseCode === 401) {
      notifyUnauthorized();
      return new HTTPUnauthorized(errorDetails);
    }
    if (responseCode === 403) {
      return new HTTPForbidden(errorDetails);
    }
    return new HTTPError(errorDetails);
  }

  if (error.request) {
    const requestHeaders = error.config?.headers;
    if (error.code === 'ECONNABORTED') {
      return new HTTPTimeoutError({
        message: error.message,
        requestHeaders,
      });
    }
    return new HTTPError({
      message: error.message,
      requestHeaders,
    });
  }

  return new HTTPError({ message: error.message });
};

const apiCall = async (method, url, data = null, headers = null, params = null) => {
  const fullUrl = BASE_URL + url;
  const finalHeaders = {
    'Content-Type': 'application/json',
    ...headers,
  };
  const reqBody = {
    method,
    url: fullUrl,
    headers: finalHeaders,
    timeout: API_REQUEST_TIMEOUT_MS,
    ...(data && { data }),
    ...(params && { params }),
  };

  try {
    const apiResponse = await finalApiRequest(reqBody);
    return apiResponse;
  } catch (err) {
    throw err instanceof APIError ? err : new APIError(err);
  }
};

export const apiCallGet = (url, headers = null, params = null) =>
  apiCall('get', url, null, headers, params);

export const apiCallPost = (url, data = null, headers = null, params = null) =>
  apiCall('post', url, data, headers, params);

export const apiCallPostBinary = (url, data = null, headers = null) => {
  const fullUrl = BASE_URL + url;
  const finalHeaders = {
    'Content-Type': 'application/json',
    ...headers,
  };
  const reqBody = {
    method: 'post',
    url: fullUrl,
    headers: finalHeaders,
    responseType: 'arraybuffer',
    timeout: API_REQUEST_TIMEOUT_MS,
    ...(data && { data }),
  };

  return new Promise((resolve, reject) => {
    axios
      .request(reqBody)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(mapAxiosError(error));
      });
  });
};

export const apiCallPut = (url, data = '', headers = null) =>
  apiCall('put', url, data, headers);

export const apiCallDelete = (url, headers = null) =>
  apiCall('delete', url, null, headers);

const finalApiRequest = (request) => {
  const finalRequest = { ...request };
  return new Promise((resolve, reject) => {
    axios
      .request(finalRequest)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(mapAxiosError(error));
      });
  });
};
